import styles from './styles.module.css';

export const HomeBanner = () => {
    return (
        <div className={styles.container}>
            <span className={styles.text}>Colors That Speak Louder Than Words</span>
        </div>
    )
}